var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Alert Details")]),_c('p',[_vm._v("Alert ID: "+_vm._s(_vm.itemId))])])}
var staticRenderFns = []

export { render, staticRenderFns }